import type { PreviewAspect } from '@/lib/export/resolveExportFormat';

export type LandscapeLayoutSwitch =
  | { kind: 'apply' }
  | { kind: 'confirm-single' };

/**
 * 16:9 is always offered. Portrait-only post layouts cannot render in
 * landscape, so switching asks the user to drop back to Single first.
 */
export function resolveLandscapeLayoutSwitch(
  { requiredAspect }: { requiredAspect?: PreviewAspect },
): LandscapeLayoutSwitch {
  if (requiredAspect === 'portrait') return { kind: 'confirm-single' };
  return { kind: 'apply' };
}
